<img
	class="pp-generated-code__copy-icon"
	[src]="icon"
	(click)="copyToClipboard()"
/>

<div #editorContainer [style.height]="height | async"></div>
